import React from 'react';

/**
 * Section — base wrapper for landing-page acts.
 * tone: visual tone token (cream/sand/leaf/ink/cream-sand)
 * rhythm: vertical breathing (tight/relaxed/grand/none)
 *
 * Tone-rhythm rules enforced at composition time, not here.
 */
const TONE = {
  cream:      'bg-[#FAF8F2] text-[#1F1D1A]',
  'cream-sand': 'bg-gradient-to-b from-[#FAF8F2] to-[#F2EEDF] text-[#1F1D1A]',
  sand:       'bg-[#F2EEDF] text-[#1F1D1A]',
  leaf:       'bg-[#F26B1A] text-white',
  ink:        'bg-[#1F1D1A] text-[#FAF8F2]',
  paper:      'bg-white text-[#1F1D1A]',
  problem:    'problem-stage text-[#1F1D1A]',
};

const RHYTHM = {
  none:    '',
  tight:   'py-12 lg:py-16',
  relaxed: 'py-20 lg:py-28',
  grand:   'py-28 lg:py-44',
};

export function Section({
  tone = 'cream',
  rhythm = 'relaxed',
  id,
  className = '',
  children,
  as: Tag = 'section',
  'data-testid': testId,
  ...rest
}) {
  return (
    <Tag
      id={id}
      data-testid={testId}
      data-tone={tone}
      className={`relative overflow-hidden ${TONE[tone] || TONE.cream} ${RHYTHM[rhythm] || RHYTHM.relaxed} ${className}`}
      {...rest}
    >
      {children}
    </Tag>
  );
}
